/// <amd-module name="Pipeline/Analytics/PipelineOutcome/Common/Types" />
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";

export interface IPipelineOutcomeTaskFailureData {
    stage?: IStageMetrics;
    topFailingTasks: ITopFailingTasks;
    trendChartData: IDailyTaskFailureData[];
}

export interface ITopFailingTasks {
    failingTasksData: IFailingTaskData[];
    failedCount: number;
}

export interface IFailingTaskData {
    taskName: string;
    failedCount: number;
}

export interface ITaskFailure {
    taskName: string;
    failedCount: number;
}

export interface IDailyTaskFailureData {
    date: string;
    taskFailures: ITaskFailure[];
}
